<!-- src/components/icons/HamburgerIcon.vue -->
<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.05371 7.05381L4.10744 4.10754M4.10744 15.8927L7.05373 12.9464M12.9463 12.9464L15.8926 15.8926M15.8926 4.10751L12.9463 7.05379M18.3333 10.0001C18.3333 14.6025 14.6024 18.3334 10 18.3334C5.39763 18.3334 1.66667 14.6025 1.66667 10.0001C1.66667 5.39771 5.39763 1.66675 10 1.66675C14.6024 1.66675 18.3333 5.39771 18.3333 10.0001ZM14.1667 10.0001C14.1667 12.3013 12.3012 14.1667 10 14.1667C7.69881 14.1667 5.83333 12.3013 5.83333 10.0001C5.83333 7.6989 7.69881 5.83341 10 5.83341C12.3012 5.83341 14.1667 7.6989 14.1667 10.0001Z" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

 
 </template>
       
 